import { ChevronDown, ChevronRight } from 'lucide-react';
import React, { useState } from 'react';

import type { NeosSyncPlanListSchema } from '@/services/api/generated/neosSyncService';

import { NeosCreateNoteAction } from './NeosCreateNoteAction';
import { NeosSyncActionItem } from './NeosSyncActionItem';

interface NeosSyncPlanCardProps {
  plan: NeosSyncPlanListSchema;
  isStale: boolean;
}

export const NeosSyncPlanCard: React.FC<NeosSyncPlanCardProps> = ({
  plan,
  isStale,
}) => {
  const [isExpanded, setIsExpanded] = useState(true);

  // Show actions that are not completed or rejected
  const activeActions = plan.actions ?? [];
  const syncTime = new Date(plan.created_at).toLocaleString('en-US', {
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
  });

  return (
    <div className="border rounded-lg bg-white">
      {/* Summary Row */}
      <button
        type="button"
        onClick={() => setIsExpanded(!isExpanded)}
        className="w-full px-4 py-3 flex items-center justify-between hover:bg-gray-50 transition-colors"
      >
        <div className="flex items-center gap-3">
          {isExpanded ? (
            <ChevronDown className="h-4 w-4 text-gray-500" />
          ) : (
            <ChevronRight className="h-4 w-4 text-gray-500" />
          )}
          <div className="text-left">
            <p className="font-medium text-gray-900">
              {activeActions.length} action
              {activeActions.length !== 1 ? 's' : ''}
            </p>
            <p className="text-sm text-gray-500">Synced {syncTime}</p>
          </div>
        </div>
      </button>

      {/* Actions List */}
      {isExpanded && activeActions.length > 0 && (
        <div className="border-t">
          <div className="divide-y">
            {activeActions.map((action) => {
              if (action.action_type === 'CREATE_NEOS_NOTE') {
                return (
                  <NeosCreateNoteAction
                    key={action.id}
                    action={action}
                    isStale={isStale}
                  />
                );
              }
              return (
                <NeosSyncActionItem
                  key={action.id}
                  action={action}
                  isStale={isStale}
                />
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
};
